import {createAsyncThunk} from "@reduxjs/toolkit";
import {apiInstanceV2} from "../../Apis/AxiosV2";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const GetAllDistributionCenter = createAsyncThunk(
    'distributionCenterSection/getAllDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get('distribution-center-service/v1/get-all', params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create department
export const CreateDistributionCenter = createAsyncThunk(
    'distributionCenterSection/createDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('distribution-center-service/v1/create', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update department
export const UpdateDistributionCenter = createAsyncThunk(
    'distributionCenterSection/updateDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put('distribution-center-service/v1/update', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// delete department
export const DeleteDistributionCenter = createAsyncThunk(
    'distributionCenterSection/deleteDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .delete(`distribution-center-service/delete-by-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ListOfUsersDistributionCenter = createAsyncThunk(
    'distributionCenterSection/listOfUsersDistributionCenter',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(`distribution-center-service/get-all-pageable-user/by-distribution-center-id/${params?.id}`, params.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// list of all user not belong to department
export const GetAllNonDistributionCenterUser = createAsyncThunk(
    'distributionCenterSection/getAllNonDistributionCenterUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`distribution-center-service/get-all-users/who-dont-belong-to-distribution-center/by-distribution-center-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
